import { isDroppableModelFile } from '@core/session/modelFileTypes'

// O que fazer com os ficheiros largados na área do modelo.
//
// Os modelos (IFC, IFC5, nuvens de pontos e, com a flag, .frag) seguem
// para o carregador, como sempre. Os BCF (.bcfzip, .bcf) vão para a
// biblioteca do módulo BCF, pela mesma importação do botão "+ Importar
// BCF". O resto ignora-se, como antes. Puro, para se testar sem DOM.

/** O nome é de um BCF (.bcfzip ou .bcf). */
export function isBcfFilename(name: string): boolean {
  return /\.(bcfzip|bcf)$/i.test(name)
}

export interface Largada<F extends { name: string }> {
  modelos: F[]
  bcf: F[]
}

/** Separa os ficheiros largados: modelos para o carregador, BCF para o
 *  módulo BCF; os outros ficam de fora. */
export function separarLargada<F extends { name: string }>(files: readonly F[]): Largada<F> {
  const modelos: F[] = []
  const bcf: F[] = []
  for (const f of files) {
    if (isBcfFilename(f.name)) bcf.push(f)
    else if (isDroppableModelFile(f.name)) modelos.push(f)
  }
  return { modelos, bcf }
}

/** A mensagem para um BCF largado sem o módulo BCF (modo local, ou um
 *  workspace sem o módulo). */
export const MENSAGEM_BCF_SEM_MODULO =
  'Para abrir um BCF é preciso o módulo BCF, que guarda os tópicos na sessão do servidor. Entra num workspace com o módulo BCF e larga o ficheiro outra vez.'

/** A mensagem de sucesso de uma importação. */
export function mensagemBcfImportado(o: {
  ficheiro: string
  nome: string
  topicos: number
  versaoNova: boolean
}): string {
  const t = `${o.topicos} tópico${o.topicos === 1 ? '' : 's'}`
  return o.versaoNova
    ? `"${o.ficheiro}" entrou como versão nova de "${o.nome}" (${t}).`
    : `BCF "${o.nome}" importado (${t}).`
}
